var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreTimingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C9.92328 1.5 7.89325 2.11581 6.16653 3.26957C4.43981 4.42332 3.09399 6.06321 2.29927 7.98183C1.50454 9.90046 1.29662 12.0116 1.70176 14.0484C2.10691 16.0852 3.10693 17.9561 4.57538 19.4246C6.04383 20.893 7.91475 21.8931 9.95155 22.2983C11.9884 22.7034 14.0996 22.4954 16.0182 21.7007C17.9368 20.906 19.5767 19.5602 20.7304 17.8334C21.8842 16.1067 22.5 14.0767 22.5 12C22.5 9.21523 21.3938 6.54445 19.4246 4.57532C17.4555 2.60619 14.7848 1.5 12 1.5ZM16.2 14.8V14.898C16.1211 15.0492 16.0025 15.1759 15.857 15.2647C15.7115 15.3535 15.5445 15.401 15.374 15.402C15.2765 15.4156 15.1775 15.4156 15.08 15.402H14.982L11.146 13.484C11.0124 13.4194 10.8967 13.3231 10.8089 13.2036C10.721 13.084 10.6637 12.9448 10.642 12.798V6.91799C10.6272 6.67665 10.7088 6.43923 10.8689 6.25807C11.0291 6.07691 11.2547 5.96684 11.496 5.95199C11.7374 5.93714 11.9747 6.01879 12.1559 6.17894C12.337 6.3391 12.4472 6.56462 12.462 6.80597V12.098L15.808 13.7779C15.9757 13.8816 16.1032 14.0393 16.1694 14.2251C16.2355 14.4109 16.2364 14.6136 16.172 14.8H16.2Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreTimingActive);
export default __webpack_public_path__ + "static/media/store-timing-active.65a99ae2c73dd7c66d42c4e75019eccf.svg";
export { ForwardRef as ReactComponent };